import { useParams } from "next/navigation";
import { parseLocale } from "../helpers/parseLocale";

export function useSelectedLocale() {
  const locale = useParams().locale;
  return parseLocale(locale);
}
